module.exports = __webpack_public_path__ + "media/images/logos/linkedin-bb933d6809d6410387a075ae885efb00.png";